module.exports = __webpack_public_path__ + "static/img/bgimg1.19d04693.png";